import { render, staticRenderFns } from "./AddGroupNumber2024.vue?vue&type=template&id=f0c3dd4e&scoped=true"
import script from "./AddGroupNumber2024.vue?vue&type=script&lang=js"
export * from "./AddGroupNumber2024.vue?vue&type=script&lang=js"
import style0 from "./AddGroupNumber2024.vue?vue&type=style&index=0&id=f0c3dd4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c3dd4e",
  null
  
)

export default component.exports